module.exports = __webpack_public_path__ + "img/1c.cfe6265e.svg";